<template>
  <div class="page">
    <!--    导出  Export    导入物流信息 importLogisticsInfo-->
    <!--    订单详情   orderDetail-->
    <!--    开票 管理&#45;&#45;&#45;&#45;  开票-->

    <div class="form-box">
      <el-form @submit.native.prevent label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="searchData.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品名称:">
              <el-input v-model="searchData.productName" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付时间：">
              <el-date-picker :default-time="['00:00:00', '23:59:59']" v-model="valueTime" type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                @change="handlePicker"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-form-item label="型号:">-->
        <!--          <el-input v-model="searchData.productSkuName" placeholder="请输入售后单号" clearable></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <div class="flex">
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
            <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--工具条-->
    <!--列表-->
    <el-table ref="tables" :data="tableList" highlight-current-row v-loading="listLoading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="productName" label="商品名称" width="200" align="center"></el-table-column>
      <el-table-column prop="orderNo" label="订单号" width="250" align="center"></el-table-column>
      <el-table-column prop="resellerName" label="订单来源" align="center"></el-table-column>
      <el-table-column prop="productName" label="商品名称" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span v-if="Array.isArray( scope.row.orderPurchases) &&  scope.row.orderPurchases.length > 0">{{-->
        <!--                            scope.row.orderPurchases[0].orderPurchaseNo-->
        <!--                          }}</span>-->

        <!--            &lt;!&ndash;            {{ scope.row.orderPurchases[0]?.orderPurchaseNo }}&ndash;&gt;-->
        <!--          </template>-->
      </el-table-column>
      <!--        <el-table-column prop="resellerName" label="品牌" align="center"></el-table-column>-->
      <!--        <el-table-column prop="supplierName" label="订单来源" width="120" align="center"></el-table-column>-->
      <!--        <el-table-column label="品类" align="center">-->
      <!--&lt;!&ndash;          <template slot-scope="scope">&ndash;&gt;-->
      <!--&lt;!&ndash;            <span style="display: inline-block;margin-right:10px;">{{
          &ndash;&gt;-- >
          < !-- &lt; ! & ndash;                scope.row.orderItems && scope.row.orderItems[0] && & ndash;&gt;-- >
          < !-- &lt; ! & ndash;                scope.row.orderItems[0].productSkuName & ndash;&gt;-- >
          < !-- &lt; ! & ndash;
        }}</span>&ndash;&gt;-->
      <!--&lt;!&ndash;          </template>&ndash;&gt;-->
      <!--        </el-table-column>-->
      <!--        <el-table-column label="型号" align="center">-->
      <!--&lt;!&ndash;          <template slot-scope="scope">&ndash;&gt;-->
      <!--&lt;!&ndash;                        <span&ndash;&gt;-->
      <!--&lt;!&ndash;                            style="display: inline-block;margin-right:10px;"> {{
          &ndash;&gt;-- >
          < !-- &lt; ! & ndash;                            scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName & ndash;&gt;-- >
          < !-- &lt; ! & ndash;
        }}</span>&ndash;&gt;-->
      <!--&lt;!&ndash;          </template>&ndash;&gt;-->
      <!--        </el-table-column>-->
      <el-table-column prop="quantity" label="数量" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            {{-->
        <!--              scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
        <!--            }}-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="amount" label="金额" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            <span style="display: inline-block;margin-right:10px;">{{-->
        <!--                scope.row.orderItems && scope.row.orderItems[0] &&-->
        <!--                scope.row.orderItems[0].unitPrice-->
        <!--              }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="amount" label="可开票金额" width="120" align="center">
      </el-table-column>
      <el-table-column prop="creationTime" label="支付时间" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
        <!--                       @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
        <!--            </el-button>-->
        <!--          </template>-->
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="开票确认" :visible.sync="invoiceDialog" width="30%" :show-close="false" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item prop="invoiceType" label="发票类型">
          <el-input size="small" v-model="form.invoiceType"></el-input>
        </el-form-item>
        <el-form-item prop="invoiceRise" label="抬头">
          <el-input size="small" v-model="form.invoiceRise"></el-input>
        </el-form-item>
        <el-form-item prop="taxpayerNumber" label="纳税人识别号">
          <el-input size="small" v-model="form.taxpayerNumber"></el-input>
        </el-form-item>
        <el-form-item prop="invoiceAddress" label="地址">
          <el-input style="width:200px;" type="textarea" :autosize="{ minRows: 2 }" size="small"
            v-model="form.invoiceAddress"></el-input>
        </el-form-item>
        <el-form-item prop="invoiceBank" label="开户行">
          <el-input size="small" v-model="form.invoiceBank"></el-input>
        </el-form-item>
        <el-form-item prop="invoiceBankAccount" label="银行账户">
          <el-input size="small" v-model="form.invoiceBankAccount"></el-input>
        </el-form-item>
        <el-form-item prop="invoiceMobile" label="电话">
          <el-input size="small" v-model="form.invoiceMobile"></el-input>
        </el-form-item>
        <el-form-item prop="billingNum" label="本次开票订单数">
          <el-input :disabled=true size="small" v-model="form.billingNum"></el-input>
        </el-form-item>
        <el-form-item prop="billingAmount" label="本次开票金额">
          <el-input :disabled=true size="small" v-model="form.billingAmount"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('form')">取 消</el-button>
        <el-button type="primary" @click="invoiceConfirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload, GetBillingOrders,
  FinanceBillingCreate,
  GetBillingOrderList, ResellerVerify
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  name: "Detail",
  components: { Toolbar },
  data() {
    return {
      distributorId: null,
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [{ 'id': 1 }],
      productNavTypeTreeList: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: '',
        productName: '',
        PayStartTime: null,
        PayEndTime: null,
        Id: null
      },
      value: '',
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      invoiceDialog: false,
      totalAmount: 0,
      form: {
        resellerId: null,
        resellerName: '',
        invoiceType: '',
        invoiceRise: '',
        taxpayerNumber: '',
        invoiceAddress: '',
        invoiceBank: '',
        invoiceBankAccount: '',
        invoiceMobile: '',
        billingNum: null,
        amount: null,
        financeBillingOrderIds: []
      },
      rules: {
        invoiceType: [
          { required: true, message: '请输入发票类型', trigger: 'blur' }
        ],
        invoiceRise: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        taxpayerNumber: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        invoiceAddress: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        invoiceBank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        invoiceMobile: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        billingNum: [
          { required: true, message: '请输入本次开票订单数', trigger: 'blur' }
        ],
        billingAmount: [
          { required: true, message: '请输入本次开票金额', trigger: 'blur' }
        ]
      },
      currentInvoiceData: {}
    };
  },
  created() {
    // this.getProductNavTypeTree();
    // this.getBrandList();
    if (this.$route.query.row) {
      let row = JSON.parse(this.$route.query.row)
      console.log('row', row)
      this.currentInvoiceData = row;
      this.distributorId = row.id;
      this.searchData.Id = row.id;
      this.form.resellerId = row.id;
      // // this.orderId = this.$route.query.orderId;
      console.log('-----', this.distributorId);
      // // this.getDetail(this.$route.query.Id)
      this.getTableList();
    } else {
      return this.$message.error('供应商Id,参数缺失')
    }

  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.billingNum = null;
      this.form.financeBillingOrderIds = [];
      this.currentRow = [];
      this.form.billingAmount = null;
      this.invoiceDialog = false;
      this.$refs.tables.clearSelection();

    },
    invoiceConfirm(formName) {

      let that = this;
      this.invoiceDialog = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let myreg = /^1[34578]\d{9}$/;
          // let myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
          if (!myreg.test(this.form.invoiceMobile)) {
            return this.$message.error('手机号有误, 请重试')
          }
          console.log('this.form', this.form);
          this.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(async () => {

            let res = await FinanceBillingCreate(this.form);
            console.log('rees', res);
            if (res.data.success) {
              this.currentRow = [];
              this.$refs[formName].resetFields();
              this.form.billingNum = null;
              this.form.financeBillingOrderIds = [];
              this.form.billingAmount = null;
              this.$refs.tables.clearSelection();
              this.$message.success('审核成功')
              // this.$refs.tables.clearSelection();
              this.invoiceDialog = false
              await this.getTableList();
            } else {
              that.$message.error(res.data.error.message || '获取数据失败, 请重试')
            }

          }).catch(() => {
            console.log('er')
            // this.verifyData = {}
            // this.totalAmount = null
            // this.currentRow = [];
            // that.$refs.tables.clearSelection();
          });


        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // resetForm(formName) {
    //   this.$refs[form].resetFields();
    // }

    makeInvoice() {
      if (this.currentRow.length <= 0) {
        return this.$message.error('请选择要开票的订单')
      }
      // this.currentRow && this.currentRow
      console.log('开票')
      this.form.invoiceType = this.currentInvoiceData.invoiceType;
      this.form.invoiceRise = this.currentInvoiceData.invoiceRise;
      this.form.taxpayerNumber = this.currentInvoiceData.taxpayerNumber;
      this.form.invoiceAddress = this.currentInvoiceData.invoiceAddress;
      this.form.invoiceBank = this.currentInvoiceData.invoiceBank;
      this.form.invoiceBankAccount = this.currentInvoiceData.invoiceBankAccount;
      this.form.invoiceMobile = this.currentInvoiceData.invoiceMobile;
      this.form.resellerName = this.currentInvoiceData.name;
      // this.form.billingNum = this.currentInvoiceData.billingNum;
      this.form.billingNum = this.currentRow.length;
      this.invoiceDialog = true;
    },
    dealerDetail() {
      this.$router.push('/Financial/DealerFinancialManage/Detail')
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    orderDetail(button, index, row) {
      // this.$router.push(
      //   `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    async getTableList(searchData) {
      this.loading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await GetBillingOrderList(this.searchData);
      if (res.data.success) {
        this.listLoading = false;
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.error.message);
      }
      console.log('已收货', res);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.searchData.PayStartTime = null
        this.searchData.PayEndTime = null
      } else {
        this.searchData.PayStartTime = date[0]
        this.searchData.PayEndTime = date[1]
      }
    },
    resetFun() {
      this.searchData.PageIndex = 1;
      this.searchData.PageSize = 10;
      this.searchData.orderNo = '';
      this.searchData.productName = '';
      this.searchData.PayStartTime = null;
      this.searchData.PayEndTime = null;
      this.valueTime = [];
      this.getTableList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
      let total = 0;
      let orderIds = []
      val.forEach(item => {
        total += item.amount
        orderIds.push(item.id)
      })
      // this.ResellerVerifyOrderDto.resellerOrderType = [val[0].resellerOrderType];
      this.form.financeBillingOrderIds = orderIds;
      this.form.billingAmount = total;
      console.log('this.form', this.form);
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      this.listLoading = false;
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

